var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.visivel ? _c('div', {
    staticClass: "danfe-overlay",
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.fechar.apply(null, arguments);
      }
    }
  }, [_c('div', {
    ref: "danfeContainer",
    staticClass: "danfe-container"
  }, [_c('div', {
    staticClass: "danfe-toolbar no-print"
  }, [_vm._m(0), _c('div', {
    staticClass: "danfe-toolbar__acoes"
  }, [_c('button', {
    staticClass: "danfe-btn danfe-btn--primary mr-2",
    attrs: {
      "disabled": !_vm.podeImprimir
    },
    on: {
      "click": _vm.imprimir
    }
  }, [_c('i', {
    staticClass: "fas fa-print mr-1"
  }), _vm._v("Imprimir ")]), _c('button', {
    staticClass: "danfe-btn danfe-btn--light",
    on: {
      "click": _vm.fechar
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })])])]), _vm.carregando ? _c('div', {
    staticClass: "danfe-loader no-print"
  }, [_c('span', {
    staticClass: "spinner-border mr-2"
  }), _vm._v("Carregando dados... ")]) : _vm.erro ? _c('div', {
    staticClass: "danfe-erro"
  }, [_c('i', {
    staticClass: "fas fa-exclamation-circle mr-2 text-danger"
  }), _vm._v(_vm._s(_vm.erro) + " ")]) : _vm.htmlDanfePadrao ? _c('div', {
    staticClass: "danfe-html-wrap"
  }, [_c('iframe', {
    staticClass: "danfe-html-frame",
    attrs: {
      "srcdoc": _vm.htmlDanfePadrao,
      "title": "Pré-visualização DANFE NFC-e"
    }
  })]) : _c('div', {
    staticClass: "danfe-erro"
  }, [_vm._v(" Pré-visualização da DANFE não disponível para esta nota. ")])])]) : _vm._e();
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "danfe-toolbar__titulo"
  }, [_c('i', {
    staticClass: "fas fa-file-invoice mr-2"
  }), _vm._v("DANFE NFC-e ")]);
}];
export { render, staticRenderFns };